// extracted by mini-css-extract-plugin
export default {"productCarousel":"H0-z"};